import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

// =============================================================================
// Effects Field Icons
// =============================================================================

export function WebsiteChevronDown(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "WebsiteChevronDown",
    viewBox: "0 0 24 24",
    path: (
      <polyline
        points="6 9 12 15 18 9"
        stroke="currentColor"
        strokeWidth="2"
        className="icon-outline"
      />
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function Sparkle(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "Sparkle",
    viewBox: "0 0 24 24",
    path: (
      <path
        d="M12 3l1.5 5.5L19 10l-5.5 1.5L12 17l-1.5-5.5L5 10l5.5-1.5L12 3z"
        stroke="currentColor"
        strokeWidth="2"
        className="icon-outline"
      />
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function Eye(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "WebsiteEye",
    viewBox: "0 0 24 24",
    path: (
      <>
        <path
          d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <circle
          cx="12"
          cy="12"
          r="3"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function Overflow(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "Overflow",
    viewBox: "0 0 24 24",
    path: (
      <>
        <polyline
          points="5 9 2 12 5 15"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <polyline
          points="9 5 12 2 15 5"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <polyline
          points="15 19 12 22 9 19"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <polyline
          points="19 9 22 12 19 15"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="2"
          y1="12"
          x2="22"
          y2="12"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="12"
          y1="2"
          x2="12"
          y2="22"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function Sliders(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "Sliders",
    viewBox: "0 0 24 24",
    path: (
      <>
        <line
          x1="4"
          y1="21"
          x2="4"
          y2="14"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="4"
          y1="10"
          x2="4"
          y2="3"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="12"
          y1="21"
          x2="12"
          y2="12"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="12"
          y1="8"
          x2="12"
          y2="3"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="20"
          y1="21"
          x2="20"
          y2="16"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="20"
          y1="12"
          x2="20"
          y2="3"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="1"
          y1="14"
          x2="7"
          y2="14"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="9"
          y1="8"
          x2="15"
          y2="8"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="17"
          y1="16"
          x2="23"
          y2="16"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}
